<template>
  <expandable-card>
    <template #default="{ isExpanded }">
      <v-card-title v-if="isExpanded">
        {{ $t('views.technicalDirector.titles.projectsList') }}
        <v-spacer />
        <v-text-field
          v-model="search"
          :label="$t('views.technicalDirector.search')"
          single-line
          hide-details
          clearable
          clear-icon="$fas fa-xmark"
          prepend-inner-icon="$fas fa-search"
        />
      </v-card-title>
      <v-data-table
        :custom-sort="sortByKpiTrendAndDate"
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        hide-default-footer
        sort-by="kpi"
        :sort-desc="true"
        fixed-header
        height="100%"
        :search="search"
        class="row-pointer overflow-auto"
        :dense="!isExpanded"
        @click:row="(item) => onProjectClicked(item)"
      >
        <template #[`item.kpi`]="{ item }">
          <TrendChip
            :trend="item.kpi.trend"
            :date="item.kpi.date"
          />
        </template>
        <template #[`item.weather`]="{ item }">
          {{ mixin_formatWeather(item) }}
        </template>
      </v-data-table>
    </template>
  </expandable-card>
</template>

<script>
import TrendChip from '../Charts/TrendChip.vue'
import customSortMixin from '@/mixins/customSortMixin'
import technicalManagerMixin from '@/mixins/technicalManagerMixin'
import ExpandableCard from '@/components/core/ExpandableCard.vue'

export default {
  name: 'TDSuppliers',
  components: {
    TrendChip,
    ExpandableCard,
  },
  mixins: [customSortMixin, technicalManagerMixin],
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('views.technicalDirector.headers.project'),
          value: 'project',
        },
        {
          text: this.$t('views.technicalDirector.headers.location'),
          value: 'location',
        },
        {
          text: this.$t('views.technicalDirector.headers.weather'),
          value: 'weather',
        },
        {
          text: this.$t('views.technicalDirector.headers.kpi'),
          value: 'kpi',
        },
      ],
      search: '',
    }
  },

  methods: {
    onProjectClicked(item) {
      const routeData = this.$router.resolve({
        path: '/dashboard/site-superintendent',
        query: { project: item._id },
      })

      window.open(routeData.href, '_blank')
    },
  },
}
</script>
